import { render, staticRenderFns } from "./MemberRegistration.vue?vue&type=template&id=89a89eec&scoped=true"
import script from "./MemberRegistration.vue?vue&type=script&lang=js"
export * from "./MemberRegistration.vue?vue&type=script&lang=js"
import style0 from "./style.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./MemberRegistration.vue?vue&type=style&index=1&id=89a89eec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89a89eec",
  null
  
)

export default component.exports